namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_select_list, {
		
		Pick: {
			Option_label: {
				flex: {
					grow: 1,
				},
			},
			Trigger: {
				justify: {
					content: 'center',
				},
			},
		},
		
	} )
	
}
